import { Injectable } from '@angular/core';
import { ApiResponseUserData, UserData } from '../models/user-data.model';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AdminService {
  userApiUrl = `${environment.apiGatewayUrl}user`;
  cognitoApiUrl = `${environment.apiGatewayUrl}cognito/search`;
  cachedUserEmails: string[] = [];

  constructor(private readonly http: HttpClient) {}

  async getUserList(pageSize = 100): Promise<ApiResponseUserData> {
    const url = this.userApiUrl;
    const urlParams = new HttpParams().set('page_size', pageSize);

    const resAsObs = this.http.get<ApiResponseUserData>(url, {
      params: urlParams,
    });
    const response = await firstValueFrom(resAsObs);
    this.cachedUserEmails = response.users.map((user) => user.email);
    return response;
  }

  createUser(userData: UserData): Promise<UserData> {
    const formattedUserData = {
      prid: userData.prid,
      name: userData.name,
      email: userData.email,
      role: userData.role as string,
      status: 'active',
      approved_by: userData.approvedBy,
      regions: userData.regions,
      markets: userData.markets,
      therapeutic_areas: userData.therapeutic_areas,
    };

    const url = this.userApiUrl;
    const resAsObs = this.http.post<UserData>(url, formattedUserData);
    return firstValueFrom(resAsObs);
  }

  getUserByPrid(prid: string): Promise<UserData> {
    const url = `${this.userApiUrl}/${prid}`;
    const resAsObs = this.http.get<UserData>(url);
    return firstValueFrom(resAsObs);
  }

  cognitoSearchByEmail(email: string): Promise<any> {
    const url = this.cognitoApiUrl;
    const payload = { email: email };
    const resAsObs = this.http.post<any>(url, payload);
    return firstValueFrom(resAsObs);
  }

  listAllCognitoUsers() {
    const url = this.cognitoApiUrl;
    const payload = { list_all_users: true };
    const resAsObs = this.http.post<any>(url, payload);
    return firstValueFrom(resAsObs);
  }
}
